var Aneox;
(function (Aneox) {
  (function (Sequences) {
    'use strict';

    var Distributors = (function () {

      var self;
      var animations;
      var timeline;

      var hasPlayedThroughAnimation = {};

      function Distributors(anims) {
        self = this;
        animations = anims;
        
        timeline = new TimelineMax({ paused: true });

        timeline
        .add(animations.OpeningTimeline($('#distributors-opening')))
        .addPause()
        .addLabel('main')
        .add(animations.TextTimeline($('#distributors-list-text')))
        .add(animations.SubtitleTimeline($('#distributors-main')));
      }

      Distributors.prototype.mastEnterAnimation = function() {
        timeline.play();
      };

      Distributors.prototype.mainEnterAnimation = function() {
        if (timeline.time() > timeline.getLabelTime('main')) return;
        timeline.seek('main').play();
      };

      Distributors.prototype.fastForwardAnimations = function() {
        timeline.pause().progress(1);
      };

      Distributors.prototype.resetAnimations = function() {
        timeline.pause().progress(0);
      }

      Distributors.prototype.handleWindowResize = function(bodyWidth, bodyHeight) {

      };


      return Distributors;
    })();

    Sequences.Distributors = Distributors;
  })(Aneox.Sequences || (Aneox.Sequences = {}));
})(Aneox || (Aneox = {}));